<rask-container-block>
  <ng-container header>
    <rask-header size="2" underline>{{ 'DESTINERINGSOMRADEN_SOK_HEADER' | translate }}</rask-header>
  </ng-container>
  <form [formGroup]="form" (ngSubmit)="search()" autocomplete="off">
    <div class="formContainer">
      @if (handelssortimentsgrupper) {
        <rask-tree-selector
          class="w-100"
          [label]="'DESTINERINGSOMRADEN_HANDELSSORTIMENT' | translate"
          [manualItemSync]="true"
          [syncOnClear]="true"
          [items]="handelssortimentsgrupper"
          formControlName="handelssortiment">
        </rask-tree-selector>
      }

      <rask-multi-selector
        aid="inputMottagningsplatser"
        class="col-12"
        label="{{'DESTINERINGSOMRADEN_MOTTAGNIGSPLATS' | translate}}"
        bindLabel="namn"
        formControlName="mottagningsplatser"
        typeToSearchText="Ange minst tre tecken"
        loadingText="Laddar..."
        notFoundText="Ingen träff"
        [minTermLength]="3"
        [typeaheadFn]="searchForMottagningsplatsTypeAhead"
        [selected]="form.value.mottagningsplatser">
      </rask-multi-selector>

      <rask-input
        label="{{'DESTINERINGSOMRADEN_FRITEXT' | translate}}"
        class="w-100"
        formControlName="fritext">
      </rask-input>

      <rask-radiobutton-group
        label="{{ 'DESTINERINGSOMRADEN_AKTIV' | translate }}"
        [buttons]="aktivRadiobuttons"
        class="w-100"
        formControlName="aktiv">
      </rask-radiobutton-group>
    </div>

    <ng-container footer>
      <rask-submit-button aid="tplSokArbetsorder" color="primary">
        {{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}
      </rask-submit-button>
    </ng-container>

  </form>

</rask-container-block>